<template>
  <div class="lineList flex-col-fJstart-fAstart">
    <div
      class="js_chantier_toggleDetail listProducts flex-fJbetween-fAcenter width100"
      @click="toggle(tagname)"
    >
      {{ labelseemore }}
      <span
        class="flex-fJcenter-fAcenter pixel_32"
        :class="isToggle?'icon-arrow2-up':'icon-arrow2-down'"
      />
    </div>
    <div
      v-if="chantierProducts"
      v-show="isToggle"
      class="listProducts flex-col-fJstart-fAstart"
    >
      <a
        v-for="(chantierProduct,chantierProductKey) in chantierProducts"
        class="flex-fJstart-fAcenter"
        :key="chantierProductKey"
        :href="chantierProduct.lien"
        target="_blank"
      >
        {{ chantierProduct.libelle }}
      </a>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    tagname: {
      type: String,
      default: ''
    },
    labelseemore: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      isToggle: false,
      chantierProducts: null
    }
  },
  methods: {
    getTagDetails: function(tagName) {
      return new Promise((resolve, reject) => {
        axios.get('/tag/chantier/details-panier/' + tagName).then(
          response => {
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      })
    },
    toggle: function(tagname) {
      this.isToggle = !this.isToggle
      this.getTagDetails(tagname).then(
        response => {
          this.chantierProducts = response
        },
        response =>
          console.log(
            'fetch chantierProducts Error : ' + JSON.stringify(response)
          )
      )
    }
  }
}
</script>
